import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { getCurrentExchangeRate } from "@/integrations/supabase/services";
import { format } from "date-fns";

const ExchangeRateInfoCard = () => {
  const { data: exchangeRate, isLoading } = useQuery({
    queryKey: ['current-exchange-rate'],
    queryFn: getCurrentExchangeRate,
  });

  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center">Cargando...</div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Tasa USD/Bs</CardTitle>
        <DollarSign className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="space-y-1">
          <div className="text-2xl font-bold">
            {exchangeRate?.usd_to_bs.toFixed(2) || "ND"} Bs
          </div>
          <div className="text-xs text-muted-foreground">
            Actualizado: {exchangeRate ? format(new Date(exchangeRate.date), 'dd/MM/yyyy') : 'Hoy'}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ExchangeRateInfoCard;